/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface DiscreteTextValueListDto
 */
export interface DiscreteTextValueListDto {
    /**
     * 
     * @type {string}
     * @memberof DiscreteTextValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteTextValueListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteTextValueListDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteTextValueListDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof DiscreteTextValueListDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscreteTextValueListDto
     */
    availableValues?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscreteTextValueListDto
     */
    selectedValues?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteTextValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscreteTextValueListDto
     */
    $type?: DiscreteTextValueListDtoTypeEnum;
}


/**
 * @export
 */
export const DiscreteTextValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersDiscreteTextValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.DiscreteTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DiscreteTextValueListDtoTypeEnum = typeof DiscreteTextValueListDtoTypeEnum[keyof typeof DiscreteTextValueListDtoTypeEnum];



/**
 * Check if a given object implements the DiscreteTextValueListDto interface.
 */
export function instanceOfDiscreteTextValueListDto(value?: unknown): value is DiscreteTextValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DiscreteTextValueListDtoTypeEnum)[0];
}

export function DiscreteTextValueListDtoFromJSON(json: any): DiscreteTextValueListDto {
    return DiscreteTextValueListDtoFromJSONTyped(json, false);
}

export function DiscreteTextValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscreteTextValueListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'availableValues': json['availableValues'] == null ? undefined : json['availableValues'],
        'selectedValues': json['selectedValues'] == null ? undefined : json['selectedValues'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DiscreteTextValueListDtoToJSON(value?: DiscreteTextValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'name': value['name'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'availableValues': value['availableValues'],
        'selectedValues': value['selectedValues'],
        'isEnabled': value['isEnabled'],
        '$type': value['$type'],
    });
}

